module.exports = __webpack_public_path__ + "static/about-team-graphic-6f9444bb5b80b2123972abcb1bc95d24.svg";